export const Icons = {
  PRIVATE_RECCO: require('./private-recco-icon.svg').default as '',
  RECCO_ICON: require('./recco-icon.svg').default as '',
  SQUAD_ICON: require('./squad-icon.svg').default as '',
  SOUND_ON: require('./sound-on.svg').default as '',
  SOUND_OFF: require('./sound-off.svg').default as '',
  USER_AVATAR: require('./user-avatar.svg').default as '',
  RECCO: require('./recco.svg').default as '',
  FAM: require('./squad.svg').default as '',
  PERK: require('./perk.svg').default as '',
  PUBLIC_GLOBE: require('./public-recco-icon.svg').default as '',
  GIFT: require('./gift.svg').default as '',
  UPLOAD: require('./upload.svg').default as '',
  RECCO_2: require('./recco-2.svg').default as '',
  RECCO_3: require('./recco-3.svg').default as '',
  BACK: require('./back.svg').default as '',
  HASHTAG: require('./hashtag.svg').default as '',
  ZOOM: require('./zoom.svg').default as '',
  CLAIM: require('./claim.svg').default as '',
  SHARE: require('./share.svg').default as '',
  SEARCH: require('./search.svg').default as '',
  RECCO_ORANGE: require('./recco-orange.svg').default as '',
  GIFT_ORANGE: require('./gift-orange.svg').default as '',
  SQUAD_ORANGE: require('./squad-orange.svg').default as '',
  DITTO_ORANGE: require('./ditto-orange.svg').default as '',
  COMMENT_ORANGE: require('./comment-orange.svg').default as '',
  SHARED_ORANGE: require('./shared-orange.svg').default as '',
  CLOSE: require('./close.svg').default as '',
  CLOSE_WHITE: require('./close-white.svg').default as '',
  CALL: require('./call.svg').default as '',
  VISIBILITY_PUBLIC: require('./visibility-public.svg').default as '',
  VISIBILITY_FAM: require('./visibility-fam.svg').default as '',
  RECCO_COMMENTS: require('./comment.svg').default as '',
  RECCO_SHARES: require('./recco-shares.svg').default as '',
  RECCO_HIFIS: require('./hi-fi.svg').default as '',
  RECCO_WHITE_LOGO: require('./recco-white-logo.svg').default as '',
  ADD_FILE_ICON: require('./add-file-icon.svg').default as '',
  ACTIVE_AURA: require('./active-aura.svg').default as '',
  BLUE_RECCO: require('./blue-recco.png'),
  CRED_ICON: require('./cred-icon.svg').default as '',
  RECCO_ICON_V2: require('./recco-icon-v2.svg').default as '',
  SKILL_ICON: require('./skill-icon.svg').default as '',
  ORGANIZATION_ICON: require('./organization-icon.svg').default as '',
  LOCATION: require('./location.svg').default as '',
  CALENDAR: require('./calendar.svg').default as '',
  GRAY_DOT: require('./gray-dot.svg').default as '',
  FILTER: require('./filter.svg').default as '',
  HI_FI_ICON: require('./hi-fi-icon.svg').default as '',
  RECCO_REAL: require('./recco-real.svg').default as '',
  OVERVIEW: require('./overview.svg').default as '',
  EDUCATION: require('./education.svg').default as '',
  TIMELINE: require('./timeline.svg').default as '',
  AI_SPARKLES: require('./ai-sparkles.svg').default as '',
  JOB_BRIEFCASE: require('./job-briefcase.svg').default as '',
  TARGET_BULLSEYE: require('./target-bullseye.svg').default as '',
  VECTOR_PATTERN: require('./vector.svg').default as '',
  MAIL_ICON: require('./mail-icon.svg').default as '',
  BUILDING_ICON: require('./building-icon.svg').default as '',
  LINK_ICON: require('./link-icon.svg').default as '',
  ARROW_LEFT: require('./arrow-left.svg').default as '',
  SETTINGS_GEAR: require('./settings-gear.svg').default as '',
  ACTIVE_SETTINGS_GEAR: require('./active-settings.svg').default as '',
  HOME_FILLED: require('./home-filled.svg').default as '',
  HOME_OUTLINE: require('./home-outline.svg').default as '',
  SEARCH_MAGNIFYING_GLASS: require('./search-magnifying-glass.svg').default as '',
  MAGNIFYING_GLASS_BLACK: require('./magnifying-glass-black.svg').default as '',
  FILLED_MAGNIFYING_GLASS: require('./magnifying-glass-filled.svg').default as '',
  MENU_OPTIONS: require('./menu-options.svg').default as '',
  LOGOUT_SIGN_OUT: require('./logout-sign-out.svg').default as '',
  DEFAULT_LOGO: require('./org-logo.svg').default as '',
  PLUS_SIGN: require('./plus-sign.svg').default as '',
  NO_OPPORTUNITY: require('./no-opportunity.svg').default as '',
  VIDEO_ICON: require('./video-icon.svg').default as '',
  THREE_DOT: require('./three-dot.svg').default as '',
  CLOCK: require('./clock.svg').default as '',
  SANDY_LOADING: require('./sandy-loading.svg').default as '',
  CLOCK_ICON: require('./clock-icon.svg').default as '',
  CURRENCY_CIRCLE_DOLLAR: require('./currency-circle-dollar.svg').default as '',
  MAP_PIN: require('./map-pin.svg').default as '',
  TRASH: require('./trash-icon.svg').default as '',
  XCIRCLE: require('./x-circle.svg').default as '',
  XCIRCLE_WHITE: require('./x-circle-white.svg').default as '',
  CHECK_CIRCLE: require('./check-circle.svg').default as '',
  ONBOARDING_CHECK: require('./onboarding-check.svg').default as '',
  PHONE: require('./phone.svg').default as '',
  RIGHT_CARET: require('./right-caret.svg').default as '',
  EMAIL: require('./email.svg').default as '',
  CARET_LEFT: require('./caret-left.svg').default as '',
  ARROW_UP_RIGHT: require('./arrow-up-right.svg').default as '',
  MAGINFYING_BLACK_SEARCH_ICON: require('./magnifying-glass-black.svg').default as '',
  BOOKMARK: require('./bookmark.svg').default as '',
  BOOKMARK_FILLED: require('./bookmard-saved.svg').default as '',
  SIGNUP_STAR: require('./signup-star.svg').default as '',
  NO_ACTIVITY: require('./no-activity.svg').default as '',
};
